<template>
  <visibility-observer
    @visible="process"
    :threshold="0.5"
    class="infinite-scroll"
  >
    <img src="images/loading.svg" />
  </visibility-observer>
</template>

<script>
import VisibilityObserver from '@/components/VisibilityObserver.vue'

export default {
  name: 'InfiniteScroll',

  components: {
    VisibilityObserver,
  },

  methods: {
    async process(visibilityObserver) {
      try {
        visibilityObserver.unobserve()

        await this.$listeners.process({
          // end: () => this.endProcessing(visibilityObserver),
          // process: () => this.process(visibilityObserver),
        })
      } finally {
        visibilityObserver.observe()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.infinite-scroll {
  $height: 24px;

  box-sizing: content-box;
  padding: 1rem;
  height: $height;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  > img {
    height: $height * 3.33333;
  }
}
</style>
